const getters = {};

/**
 * user 정보
 * @returns {Object}
 */
getters.userInfo = (state) => {
  return state.userInfo.userInfo;
};
/**
 * user 상태 정보
 * @param {*} state
 * @returns {String}
 */
getters.userInfoState = (state) => {
  return state.userInfo.userInfoState;
};
/**
 * 사업자 선택 정보
 * @param {*} state
 * @returns {String}
 */
getters.registerSelect = (state) => {
  return state.userInfo.registerSelect;
};
/**
 * 사업자 처리 내역​
 * @param {*} state
 * @returns {Array}
 */
getters.userInfoHistory = (state) => {
  return state.userInfo.userInfoHistory;
};

getters.hasOTP = (state) => {
  return state.userInfo.hasOTP;
};

export default {
  ...getters,
};
